import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import SiteLogo from './SiteLogo';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="luma-footer">
            <div className="footer-container">
                {/* Logo Section */}
                <div className="footer-brand">
                    <Link to="/" className="footer-logo"><SiteLogo /></Link>
                    <p className="footer-tagline">Votre streaming, sans limites.</p>
                </div>

                {/* Links Grid */}
                <div className="footer-links-grid">
                    <div className="footer-column">
                        <h4>Navigation</h4>
                        <Link to="/">Accueil</Link>
                        <Link to="/movies">Films</Link>
                        <Link to="/series">Séries</Link>
                        <Link to="/live">Direct</Link>
                    </div>

                    <div className="footer-column">
                        <h4>Mon Compte</h4>
                        <Link to="/profile">Mon Profil</Link>
                        <Link to="/mylist">Ma Liste</Link>
                        <Link to="/profiles">Gérer les profils</Link>
                    </div>

                    <div className="footer-column">
                        <h4>Aide</h4>
                        <span>Centre d'aide</span>
                        <span>FAQ</span>
                        <span>Nous contacter</span>
                    </div>

                    <div className="footer-column">
                        <h4>Légal</h4>
                        <span>Conditions d'utilisation</span>
                        <span>Confidentialité</span>
                        <span>Mentions légales</span>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="footer-bottom">
                <p>© {currentYear} LUMA. Tous droits réservés.</p>
            </div>
        </footer>
    );
};

export default Footer;
